export default "__VITE_ASSET__239001fe__"